var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m498.67 1005h-444.12c-3.0586 0-6.0234-1.2031-8.1953-3.3789-2.1758-2.1758-3.3789-5.1406-3.3789-8.1953l0.046875-724.11h-42.98l-0.046875 775.98h489.88c18.43 0 36.027 8.8008 47.051 23.527 6.7148 8.9375 17.367 14.262 28.574 14.262h22.09c-5.6953-43.996-43.395-78.082-88.918-78.082z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.12 968.12-316.86-76.875c-5.1875-1.25-8.8477-5.8828-8.8477-11.207l0.046875-660.67-67.289 0.003906v38.668l-0.046876 723.79h431.94c-11.484-5.0508-24.406-9.6797-38.945-13.711z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.11 197.29c-77.105-22.09-278.37-67.891-333.48-80.348l-0.046875 753.98 308.38 74.793c67.102 18.664 103.59 48.949 123.37 77.43l0.046875-720.87c-1.1602-56.223-60.898-94.242-98.273-104.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1157 269.3-0.046876 724.11c0 6.3906-5.1875 11.578-11.578 11.578l-444.12-0.003906c-45.523 0-83.223 34.086-88.918 78.078h22.09c11.16 0 21.812-5.3242 28.527-14.262 11.07-14.727 28.664-23.527 47.051-23.527h489.92l0.050781-775.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m701.7 981.83h432.12l0.046875-762.46h-67.289l-0.046875 660.67c0 5.3242-3.6602 9.957-8.8477 11.207l-317.23 76.969c-14.496 4.0273-27.324 8.6094-38.762 13.613z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m734.62 945.8 308.75-74.883 0.042969-753.98c-55.109 12.457-256.38 58.258-333.48 80.348-37.375 10.742-97.113 48.766-98.273 105.22l-0.046875 720.55c19.73-28.434 56.129-58.676 123-77.246z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookWhite);
export default __webpack_public_path__ + "static/media/book-white.d92a2d02382c3f0faef6c808723d6044.svg";
export { ForwardRef as ReactComponent };